import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import AuthenticationPage from './Page/AuthenticationPage';
import ForbiddenPage from './Page/ForbiddenPage';
import InterestUri from './Enum/InterestUri';
import InterestPage from './Page/InterestPage';
import Modal from './Component/General/Modal';
import NotFound from './Page/ErrorPage';
import Redirect from './Component/General/Redirect';
import ValidatorResultPage from './Page/ValidatorResultPage';
import Login from './Component/Auth/Login';

const App: React.FC = () => (
    <Router>
        <Redirect />
        <Switch>
            <Route path="/" component={Login} exact />
            <Route path={`/rente`} component={AuthenticationPage} exact />
            <Route path={`/rente/:section(${Object.values(InterestUri).join('|')})`} component={InterestPage} exact />
            <Route path="/result/:caseId" component={ValidatorResultPage} exact />
            <Route path="/geen-toegang" component={ForbiddenPage} exact />
            <Route component={NotFound} />
        </Switch>
        <Modal />
    </Router>
);

export default App;
